/* eslint arrow-body-style: */
import { isCancel } from 'api/Helpers';
import { getSpecAttributes as apiGetSpecAttributes } from 'api/Products';
import {
	FETCH_ERROR,
	IS_FETCHING,
	RECEIVE_FILTERABLE_OPTIONS,
	RECEIVE_FILTERS,
	RECEIVE_SPEC_ATTRIBUTES,
	RESET_FILTERS,
	SET_MAX_PRICE_TEXT,
	SET_MIN_PRICE_TEXT,
} from './constants';

const receiveFilterableOptions = (catId, options) => ({
	type: RECEIVE_FILTERABLE_OPTIONS,
	catId,
	options,
});

/**
 * Save the filter options.
 * @param {object} filters
 */
const receiveFilters = filters => ({
	type: RECEIVE_FILTERS,
	filters,
});

/**
 * Set the max price textbox text.
 * @param {string} maxPriceText
 */
const setMaxPriceText = maxPriceText => ({
	type: SET_MAX_PRICE_TEXT,
	maxPriceText,
});

/**
 * Set the min price textbox text.
 * @param {string} minPriceText
 */
const setMinPriceText = minPriceText => ({
	type: SET_MIN_PRICE_TEXT,
	minPriceText,
});

/**
 * Save available product filtering options available in eSTORIS.
 * @param {object} attributes
 */
const receiveSpecAttributes = specAttributes => ({
	type: RECEIVE_SPEC_ATTRIBUTES,
	specAttributes,
});

/**
 * Clear all stored filter parameters
 */
const resetFilters = () => ({
	type: RESET_FILTERS,
});

/**
 * Error has occurred during fetch to eSTORIS.
 * @param {Error} fetchError
 */
const updateFetchError = fetchError => ({
	type: FETCH_ERROR,
	fetchError,
});

/**
 * Fetch is in progress to get available fetch options in eSTORIS.
 * @param {boolean} isFetching
 */
const updateFetchStatus = isFetching => ({
	type: IS_FETCHING,
	isFetching,
});

// Thunks
/**
 * Get a master list of all available specification attributes in eStoris
 * used for product filtering.
 * @param {axios cancel token} cancelToken
 */
const getSpecAttributes = cancelToken => {
	return (dispatch, getState) => {
		// This does not need to be refetched if we already have it.
		const { productFilter } = getState();
		if (productFilter.get('attributes').size !== 0) {
			return false;
		}

		dispatch(updateFetchStatus(true));

		return apiGetSpecAttributes(cancelToken)
			.then(response => {
				dispatch(updateFetchStatus(false));
				dispatch(receiveSpecAttributes(response.data.results));
			})
			.catch(error => {
				dispatch(updateFetchStatus(false));
				if (isCancel(error)) {
					// Request was cancelled.
					return;
				}

				dispatch(updateFetchError(error));
			});
	};
};

export {
	getSpecAttributes,
	receiveFilterableOptions,
	receiveFilters,
	receiveSpecAttributes,
	resetFilters,
	setMaxPriceText,
	setMinPriceText,
	updateFetchError,
	updateFetchStatus,
};
